import type { Review } from "@/types";

export const reviews: Review[] = [
  {
    id: "r1",
    title: "《沙漠孤星》：在最荒凉的地方，守住最亮的那颗星",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20image%20of%20a%20lone%20astronaut%20silhouette%20against%20an%20orange%20desert%20horizon%20and%20deep%20blue%20starry%20sky%2C%20contemplative%20sci-fi%20mood%2C%20high%20detail%20film%20photography&width=1200&height=675&seq=ya-review-cover-01&orientation=landscape",
    author: "银幕旅人",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20avatar%20of%20a%20thoughtful%20young%20man%20with%20glasses%20in%20soft%20warm%20studio%20light%2C%20clean%20neutral%20background%2C%20friendly%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=ya-avatar-01&orientation=squarish",
    date: "2025-09-30",
    category: "movie",
    workId: "m1",
    workTitle: "沙漠孤星",
    excerpt:
      "当肉体被困在无垠荒原，真正支撑人走下去的，往往是记忆里那一点点微弱却执拗的光。",
    content: [
      "《沙漠孤星》最聪明的地方，在于它把宏大的科幻设定悄悄收进了一个人的内心。银幕上那片橙黄无垠的荒漠，其实是一个巨大的隐喻——当世界只剩下你和你自己，你还愿意相信什么？",
      "影片的色调处理堪称教科书级别。冷冽的深蓝代表现实的残酷与宇宙的空旷，而每当主角回想起地球上的片段，画面便会涌上暖橙色的光。两种颜色在叙事中互相拉扯，构成了全片最核心的情绪张力。",
      "陈牧之导演这一次克制得令人惊讶。他没有用大段的台词去解释孤独，而是让沉默本身成为主角。那些漫长到近乎静止的镜头，恰恰是让人喘不过气的部分——你会不自觉地把自己代入那片沙漠。",
      "真正打动我的，是结尾处那段跨越光年的通讯。它没有煽情，只是轻轻地说了一句‘我还在’。可就这一句，让整部电影从一部科幻片，变成了一封写给所有孤独者的信。",
      "如果你也在某个深夜感到被世界遗忘，不妨去看看这颗沙漠里的孤星。它也许会告诉你：即使在最荒凉的地方，也有值得守候的光。",
    ],
    likes: 328,
    tags: ["科幻", "深度解析"],
  },
  {
    id: "r2",
    title: "从《长夜将尽》看华语犯罪片的美学进化",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20noir%20image%20of%20a%20rainy%20city%20street%20at%20night%20with%20warm%20orange%20lamplight%20and%20deep%20blue%20shadows%2C%20moody%20crime%20thriller%20mood%2C%20high%20detail%20film%20photography&width=1200&height=675&seq=ya-review-cover-02&orientation=landscape",
    author: "深焦评论",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20avatar%20of%20a%20confident%20female%20film%20critic%20with%20short%20hair%20in%20soft%20studio%20light%2C%20clean%20neutral%20background%2C%20elegant%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=ya-avatar-02&orientation=squarish",
    date: "2025-09-22",
    category: "movie",
    workId: "m2",
    workTitle: "长夜将尽",
    excerpt:
      "当罪案类型不再满足于‘解谜’，而开始追问人心，华语犯罪片便真正迈进了更深的层次。",
    content: [
      "《长夜将尽》是一部让人看完会在椅子上多坐几分钟的电影。它并不急着告诉你凶手是谁，而是执着地追问：当真相与情义对立，一个人该如何选择？",
      "影片的影像风格延续了近年华语犯罪片的冷调传统，但导演周砚青在冷峻的蓝调中，巧妙地点缀了暖橙色的光源——路灯、卷宗、旧照片。这些暖色不是装饰，而是记忆与情感在画面里最后的落脚点。",
      "叙事结构上，影片采用双线并进，十年前与十年后互相照应。这种结构并不新鲜，但影片的克制让它避免了故弄玄虚——每一次时空跳转，都服务于人物内心的变化。",
      "演员的表演是另一大亮点。老刑警的疲惫、搭档的欲言又止，都被精准地控制在‘不说破’的尺度里。这种留白，恰恰是类型片走向成熟的标志。",
      "如果说过去的华语犯罪片擅长制造‘谜题’，那么《长夜将尽》证明了，我们同样可以把谜题指向人心深处。",
    ],
    likes: 512,
    tags: ["犯罪", "影评专栏"],
  },
  {
    id: "r3",
    title: "《春日列车》：一趟没有终点的告别之旅",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20image%20of%20an%20old%20train%20window%20with%20cherry%20blossoms%20and%20soft%20spring%20golden%20light%2C%20gentle%20melancholic%20mood%2C%20high%20detail%20film%20photography&width=1200&height=675&seq=ya-review-cover-03&orientation=landscape",
    author: "慢镜头笔记",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20avatar%20of%20a%20gentle%20young%20woman%20with%20long%20hair%20in%20soft%20warm%20light%2C%20clean%20neutral%20background%2C%20warm%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=ya-avatar-03&orientation=squarish",
    date: "2025-09-08",
    category: "movie",
    workId: "m3",
    workTitle: "春日列车",
    excerpt:
      "有些相遇注定是用来告别的，而《春日列车》把这份遗憾，拍得温柔又体面。",
    content: [
      "《春日列车》是一部非常安静的片子。它没有激烈的冲突，也没有煽情的对白，只是让两个人在一列开往北海道的火车上，安静地度过一段路程。",
      "岩井俊介镜头的诗意一如既往。窗外的樱花、车厢里的光影、两人之间恰到好处的沉默，每一个画面都像一帧可以裱起来的照片。",
      "影片最动人的地方，在于它对‘告别’的处理。不是声嘶力竭，而是承认遗憾、祝福彼此，然后各自继续往前走。这种成熟的情感态度，在同类作品中并不多见。",
      "配乐同样值得称道，钢琴与弦乐的组合克制而温柔，从不喧宾夺主，却总在最需要的时候轻轻落下来。",
      "看完之后，你也许会想起某个曾经错过的人。但奇怪的是，那份想起并不苦涩，反而带着一点释然。这大概就是《春日列车》最温柔的力量。",
    ],
    likes: 276,
    tags: ["爱情", "文艺片"],
  },
  {
    id: "r4",
    title: "《长安十二辰》：用十二个时辰，写尽一座城的烟火与人心",
    cover:
      "https://readdy.ai/api/search-image?query=Image%20of%20a%20traditional%20chinese%20lantern%20lit%20night%20street%20with%20warm%20orange%20glow%20and%20deep%20blue%20sky%2C%20cinematic%20historical%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=ya-review-cover-04&orientation=landscape",
    author: "剧评人老陈",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20avatar%20of%20a%20mature%20male%20writer%20with%20grey%20hair%20in%20soft%20studio%20light%2C%20clean%20neutral%20background%2C%20serious%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=ya-avatar-04&orientation=squarish",
    date: "2025-09-18",
    category: "tv",
    workId: "t1",
    workTitle: "长安十二辰",
    excerpt:
      "它不是简单的‘限时解谜’，而是借悬疑的壳，装下了整座长安城的呼吸与温度。",
    content: [
      "《长安十二辰》最打动我的，不是它精巧的时间线，而是它愿意把镜头分给那些‘小人物’。卖胡饼的、巡街的、守门的——正是这些普通人的日常，让长安真正活了起来。",
      "剧集的美术与灯光堪称近年古装剧的标杆。大量的夜戏以灯笼与烛火作为主光源，暖橙色的光芒落在青石板路上，配以深蓝色的夜空，古朴又不失层次。",
      "在叙事节奏上，剧集张弛有度。紧张时短兵相接、分秒必争；舒缓时又愿意停下来，让观众看看市井的烟火气。这种节奏的把控，正是长剧集最难的部分。",
      "人物塑造同样立体。主角并非天生的英雄，而是在一次次抉择中逐渐成长。反派也不是脸谱化的恶人，其动机令人唏嘘。",
      "‘守护万家灯火’这句台词，看的时候只觉寻常，回看时才明白它的分量。这或许就是《长安十二辰》真正的野心——用一部悬疑剧，写尽一座城的温度。",
    ],
    likes: 689,
    tags: ["古装", "剧集评论"],
  },
  {
    id: "r5",
    title: "《医心仁术》：急诊科里，那些没被说出口的温柔",
    cover:
      "https://readdy.ai/api/search-image?query=Image%20of%20a%20bright%20hospital%20corridor%20with%20warm%20light%20and%20deep%20blue%20accents%2C%20clean%20hopeful%20medical%20atmosphere%2C%20high%20detail%20photography&width=1200&height=675&seq=ya-review-cover-05&orientation=landscape",
    author: "白色走廊",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20avatar%20of%20a%20composed%20young%20male%20doctor%20in%20soft%20studio%20light%2C%20clean%20neutral%20background%2C%20friendly%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=ya-avatar-05&orientation=squarish",
    date: "2025-09-14",
    category: "tv",
    workId: "t2",
    workTitle: "医心仁术",
    excerpt:
      "它没有把医生塑造成神，却因此让他们更像人——这才是医疗剧最珍贵的地方。",
    content: [
      "医疗剧最容易陷入的陷阱，是把医生神化。而《医心仁术》的难得之处，恰恰在于它愿意展示医生的疲惫、犹豫与无能为力。",
      "急诊科的设定天然带有高强度节奏，剧集没有回避这一点。抢救、会诊、家属沟通，几乎每一集都在与时间赛跑。但在这些紧张之外，它总会留出一些安静的瞬间——清晨的走廊、递过去的一杯水、一句没说出口的安慰。",
      "第二季加入的年轻医生成长线，让整部剧的视角更加丰富。新人从手忙脚乱到独当一面，观众能真切感受到那种成长的分量。",
      "值得一提的是，剧集对医患关系的刻画相当克制。它不刻意制造对立，也不回避现实困境，而是在困境中努力寻找理解的可能。",
      "如果你曾被现实中的‘白衣天使’治愈过，这部剧会让你对那身白大褂多一分敬意。",
    ],
    likes: 401,
    tags: ["医疗", "剧集评论"],
  },
  {
    id: "r6",
    title: "《星海征途》：当科幻开始认真讨论‘信任’",
    cover:
      "https://readdy.ai/api/search-image?query=Image%20of%20a%20starship%20crew%20on%20a%20bridge%20watching%20a%20vast%20orange%20planet%20through%20a%20window%2C%20deep%20blue%20starlight%2C%20cinematic%20sci-fi%20scale%2C%20high%20detail&width=1200&height=675&seq=ya-review-cover-06&orientation=landscape",
    author: "第九行星",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20avatar%20of%20a%20young%20female%20sci-fi%20enthusiast%20with%20glasses%20in%20soft%20cool%20light%2C%20clean%20neutral%20background%2C%20modern%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=ya-avatar-06&orientation=squarish",
    date: "2025-09-06",
    category: "tv",
    workId: "t4",
    workTitle: "星海征途",
    excerpt:
      "太空的辽阔只是背景，真正让这部剧立得住的，是它对人性与信任的耐心推演。",
    content: [
      "很多人看《星海征途》是冲着视觉奇观去的，但看完之后念念不忘的，往往是船上的那几个人。",
      "剧集把‘远航’设定为一个漫长而封闭的环境，这为人物关系的展开提供了绝佳的舞台。有限的空间、未知的前路，让每一次信任的建立与崩塌都显得格外沉重。",
      "外星的威胁固然惊险，但真正让观众揪心的，是船员之间那些微妙的猜忌与袒护。剧集证明了，最好的科幻往往写的是人。",
      "视觉层面，剧集同样用心。深蓝的星海与橙黄的星球形成鲜明对比，既有科学的冷峻，又不失浪漫的想象。",
      "如果你是硬科幻爱好者，也许会觉得它的科学细节不够严谨；但如果你愿意为‘人’买单，它一定不会让你失望。",
    ],
    likes: 233,
    tags: ["科幻", "剧集评论"],
  },
  {
    id: "r7",
    title: "专题：现实主义电影为何总能击中我们",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20image%20of%20an%20ordinary%20family%20sharing%20a%20meal%20in%20a%20modest%20apartment%20at%20dusk%2C%20warm%20orange%20lamp%20glow%2C%20deep%20blue%20window%20light%2C%20tender%20realistic%20mood%2C%20high%20detail&width=1200&height=675&seq=ya-review-cover-07&orientation=landscape",
    author: "现实主义观察",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20avatar%20of%20a%20calm%20middle%20aged%20male%20commentator%20in%20soft%20studio%20light%2C%20clean%20neutral%20background%2C%20thoughtful%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=ya-avatar-07&orientation=squarish",
    date: "2025-08-26",
    category: "special",
    workId: "m6",
    workTitle: "都市浮生",
    excerpt:
      "当银幕上的故事不再遥远，我们会在别人的生活里，看见自己的影子。",
    content: [
      "近年的华语影坛，现实主义题材正在悄然回归。从《都市浮生》到《稻香人家》，这些作品没有炫目的特效，却总能在观众心里留下长久的回响。",
      "现实主义电影的魅力，首先来自‘真实’。它不回避生活的琐碎与狼狈，也不刻意美化困境。正因为如此，观众才会在角色身上看到自己的影子。",
      "其次是‘共情’。好的现实题材作品，懂得把宏大的社会议题落到一个个具体的人身上。拆迁、返乡、代际关系——这些看似宏大的命题，最终都化成了一顿饭、一次争吵、一个眼神。",
      "《都市浮生》里三代人挤在老楼里的日常，之所以动人，正是因为它拍出了‘普通人的尊严’。生活或许艰难，但人们依然在认真地活着。",
      "现实题材不需要惊天动地的情节，它只需要诚实。而诚实，往往是最有力量的。",
    ],
    likes: 357,
    tags: ["专题", "现实主义"],
  },
  {
    id: "r8",
    title: "《时光信箱》：给过去的自己写一封信",
    cover:
      "https://readdy.ai/api/search-image?query=Image%20of%20a%20glowing%20letter%20beside%20an%20old%20mailbox%20on%20a%20snowy%20deep%20blue%20evening%20street%2C%20warm%20orange%20glow%2C%20dreamy%20magical%20atmosphere%2C%20high%20detail&width=1200&height=675&seq=ya-review-cover-08&orientation=landscape",
    author: "暖冬观影",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20avatar%20of%20a%20cheerful%20young%20woman%20with%20a%20warm%20smile%20in%20soft%20light%2C%20clean%20neutral%20background%2C%20friendly%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=ya-avatar-08&orientation=squarish",
    date: "2025-07-25",
    category: "movie",
    workId: "m8",
    workTitle: "时光信箱",
    excerpt:
      "如果真有一个能寄信到过去的信箱，你想说的话，会是什么？",
    content: [
      "《时光信箱》是一部非常适合在冬夜观看的电影。它温柔、缓慢，却一点也不无聊，反而像一杯热可可，暖得恰到好处。",
      "影片的核心设定其实很朴素——一个能寄信到过去的信箱。但导演高明的地方在于，他并没有让主角肆意改写人生，而是让她学会与遗憾和解。",
      "‘改变过去’从来不是重点，‘理解现在’才是。影片用一封封往来的信件，串起了女主角对亲情、爱情与自我的重新认识。",
      "色调上，影片大量使用暖橙色的灯光与深蓝色的雪夜形成对比，既有童话般的浪漫，又不失真实的温度。",
      "看完之后，你也许会想给过去的自己写一封信。不为改变什么，只为告诉他：你做得已经很好了。",
    ],
    likes: 298,
    tags: ["爱情", "治愈系"],
  },
  {
    id: "r9",
    title: "《雾都迷案》与古典推理的当代回响",
    cover:
      "https://readdy.ai/api/search-image?query=Image%20of%20a%20detective%20examining%20clues%20in%20a%20fog%20filled%20old%20library%20with%20warm%20orange%20candlelight%20against%20deep%20blue%20shadows%2C%20tense%20mystery%20mood%2C%20high%20detail&width=1200&height=675&seq=ya-review-cover-09&orientation=landscape",
    author: "推理研究所",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20avatar%20of%20a%20sharp%20male%20mystery%20writer%20with%20a%20beard%20in%20warm%20library%20light%2C%20clean%20neutral%20background%2C%20intellectual%20editorial%20headshot%2C%20high%20detail&width=200&height=200&seq=ya-avatar-09&orientation=squarish",
    date: "2025-07-18",
    category: "movie",
    workId: "m9",
    workTitle: "雾都迷案",
    excerpt:
      "雾是遮掩真相的帷幕，也是映照人心的镜子——《雾都迷案》拍出了古典推理的当代质感。",
    content: [
      "《雾都迷案》是一部带着浓郁古典气息的推理电影。浓雾、煤气灯、老图书馆，每一个元素都在向黄金时代的侦探小说致敬。",
      "但影片并不满足于复刻经典。它在传统‘解谜’的框架中，加入了更多关于记忆、创伤与救赎的思考，让整个故事有了更深的情感底色。",
      "导演对‘雾’这一意象的运用尤为精彩。雾既是遮掩真相的帷幕，也是人物内心迷惘的写照。随着真相逐渐浮出水面，雾气也随之散去。",
      "演员的表演沉稳内敛，退休警探的疲惫与执着被刻画得入木三分。年轻记者的加入，则为沉稳的叙事注入了一丝轻盈。",
      "如果你喜欢古典推理，又希望看到它长出新的枝叶，《雾都迷案》会是一个令人满意的答案。",
    ],
    likes: 187,
    tags: ["悬疑", "推理"],
  },
];